module.exports = new __parcel__URL__("gape_generative_empty.0eec5725.png").toString();